export default "/assets/30652f2877c4845e.png"